import { render, staticRenderFns } from "./AddNewItemModal.vue?vue&type=template&id=2ce7cfc5&scoped=true"
import script from "./AddNewItemModal.vue?vue&type=script&lang=js"
export * from "./AddNewItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7cfc5",
  null
  
)

export default component.exports